import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';

// INTERFACES
import { IBusinessAccountContact, ICompany } from '../../../../client/interfaces';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

import { IPaginationResponse } from './../../../interfaces/paginator.interface';
@Injectable({
  providedIn: 'root',
})
export class ClientCompanyApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _companies = new BehaviorSubject<ICompany[]>(<ICompany[]>[]);
  private readonly _currentCompany = new BehaviorSubject<ICompany | null>(
    <ICompany | null>null,
  );

  private readonly _businessAccountsContacts = new BehaviorSubject<
    IBusinessAccountContact[] | []
  >(<IBusinessAccountContact[] | []>[]);

  loading$ = this._loading.asObservable();
  companies$ = this._companies.asObservable();
  currentCompany$ = this._currentCompany.asObservable();
  businessAccountsContacts$ = this._businessAccountsContacts.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(
    params :{
      [param :string] :string | string[];
    } = {},
    enableLoading :boolean = true,
  ) :Subscription {
    if (enableLoading) {
      this._loading.next(true);
    }

    return this.apiService
      .get(`${this.environment.urlV1}/companies`, { params })
      .subscribe({
        next: ({ records } :any) => {
          this._companies.next(records.data);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getV2(
    params :{
      [param :string] :string | string[];
    } = {},
    enableLoading :boolean = true,
  ) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV1}/companies`, { params });
  }

  getById(id :number) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/clients/${id}`)
      .subscribe({
        next: (response) => {
          this._currentCompany.next(response);
          this._loading.next(false);
        },
        error: (error) => {
          this._loading.next(false);

          return throwError(() => new Error(error));
        },
      });
  }

  getCompanyContacts(params :{ [param :string] :string | string[] }) :Subscription {
    return this.apiService
      .get(
        `${this.environment.urlV2}/b2b-portal/business-account-contacts?relation[]=userAccount`,
        { params },
      )
      .subscribe({
        next: (response :any) => {
          this._businessAccountsContacts.next(response.data);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getCompanyContactsV2(params :{
    [param :string] :string | string[];
  }) :Observable<IPaginationResponse> {
    return this.apiService.get(
      `${this.environment.urlV2}/b2b-portal/business-account-contacts?relation[]=userAccount`,
      { params },
    );
  }

  setCurrentCompany(company :ICompany | null) :void {
    this._currentCompany.next(company);
  }

  setCompanies(companies :ICompany[]) :void {
    this._companies.next(companies);
  }

  setContacts(contacts :IBusinessAccountContact[]) :void {
    this._businessAccountsContacts.next(contacts);
  }

  get currentCompany() :ICompany | null {
    return this._currentCompany.value;
  }
}
